const jsonTransform = <T,>(): Transformer<string, T> => {
  let buffer = '';
  return {
    start: () => {
      buffer = '';
    },
    transform: (chunk, controller) => {
      const lines = chunk.split('\n');
      for (const line of lines) {
        buffer += line;
        try {
          const json = JSON.parse(buffer) as T;
          buffer = '';
          controller.enqueue(json);
        } catch (error) {
          if (!(error instanceof SyntaxError)) {
            controller.error(error);
          }
        }
      }
    },
    flush: (controller) => {
      if (buffer.length > 0) {
        controller.error(new Error('End of stream reached before JSON object was fully parsed.'));
      }
    },
  };
};

export class JSONDecoderStream<T> extends TransformStream<string, T> {
  public constructor() {
    super(jsonTransform());
  }
}
